import {UIStoreGiftOverlayController} from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController.ts'
import {uiManager} from '../EntryHomepage.ts'
import {Scene} from '../ui_html/UISceneTypes.ts'
import {UIStoreGiftBaseSelectionController} from '../../../shared/scripts/store/gift/UIStoreGiftBaseSelectionController.ts'
import {GiftingFlowAnalytics} from '../../../../shared/entity_datas/EntityDatas.ts'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes.ts'
import {type ColonistOneTimePurchaseType, type BigId} from '@colonist/types'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints.ts'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper.ts'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper.ts'
import {type GiftPurchaseData} from '../../../../shared/store/GiftPurchaseData.ts'

export class UIDStoreGiftOverlayController extends UIStoreGiftOverlayController {
    protected override init() {
        this.createHeaderSection()
        this.createBodySection()
    }

    // eslint-disable-next-line class-methods-use-this
    protected override async executeCheckout(giftTier: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        const result = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSaveGiftMetadata(), undefined, giftPurchaseData)
        if(result == undefined) return

        const giftMetadataId = result.json as BigId
        StorageWrapper.setGiftMetadataId(giftMetadataId)

        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulCheckoutClick)
        DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseGift, giftTier)
    }

    // eslint-disable-next-line class-methods-use-this
    protected override goToHomepage() {
        uiManager.sceneController.loadScene(Scene.MainPage)
    }

    // eslint-disable-next-line class-methods-use-this
    override hide() {
        uiManager.sceneController.loadScene(Scene.DiscordStore)
    }

    // eslint-disable-next-line class-methods-use-this
    override show() {
        uiManager.sceneController.loadScene(Scene.DiscordGifting)
    }
}
